export default "__VITE_ASSET__515a33e0__"